// export { default as addressList } from './addressList/addressList.vue';
// export { default as addAddress } from './addAddress/addAddress.vue';
// export { default as editAddress } from './editAddress/editAddress.vue';

export const addressList = (r) => require.ensure([], () => r(require("./addressList/addressList.vue")), "addressList");
export const editAddress = (r) => require.ensure([], () => r(require("./editAddress/editAddress.vue")), "editAddress");
